export const FETCH_ANALYSIS_BY_ID = 'provider/FETCH_ANALYSIS_BY_ID';
export const FETCH_CHARTDATA = 'provider/FETCH_CHARTDATA';
export const GENERATE_PDF = 'provider/GENERATE_PDF';
export const GENERATING_PDF = 'provider/GENERATING_PDF';
export const FETCHING_ANALYSIS = 'provider/FETCHING_ANALYSIS';
export const FETCHING_CHARTDATA = 'provider/FETCHING_CHARTDATA';
export const PDF_LINK = 'provider/PDF_LINK';
